import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { siteKey } from '../../../environments/environment.development';
import { NgxCaptchaModule } from 'ngx-captcha';
import { Hot100Login } from '../../../models/types';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-hot100-prijava',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxCaptchaModule],
  templateUrl: './hot100-prijava.component.html',
  styleUrl: './hot100-prijava.component.scss'
})
export class Hot100PrijavaComponent {
  raceForm: FormGroup;
  siteKey = siteKey;
  captchaToken: string | null = null;
  racers: Hot100Login[] = [];
  @Input() isOrgAdmin: boolean = false;
  
  constructor(private fb: FormBuilder, private organisationService: OrganisationServiceService) {
    this.raceForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      yearOfBirth: [null, Validators.required],
      sex: ['', Validators.required],
      address: ['', Validators.required],
      club: [''],
      phone: ['', Validators.required],
      citizenship: ['', Validators.required],
      numOfLaps: [null, Validators.required],
      timeOfArrival: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getRacers();
  }

  onCaptchaResolved(event: any) {
    this.captchaToken = event;
    console.log('Captcha resolved:', event);
  }
  onSubmit(): void {
    if (this.raceForm.valid) {
      // No need to send the captcha token anymore, just handle form submission
      this.organisationService.enrollInRace(this.raceForm.value).subscribe({
        next: (response) => {
          Swal.fire({
            icon: 'success',
            title: 'Uspešna prijava',
            text: 'Prijava na HOT100 je bila uspešna!',
          });
          window.location.reload();
        },
        error: (error) => {
          console.error('Error:', error);
          Swal.fire({
            icon: 'error',
            title: 'Napaka',
            text: 'Prišlo je do napake pri prijavi na HOT100. Prosimo, poskusite znova kasneje.',
          });
        },
      });
    } else {
      alert('Please complete the form!');
    }
  }

  getRacers(): void {
    this.organisationService.getRacers().subscribe({
      next: (response) => {
        console.log('Response:', response.racers);
        this.racers = response.racers;
        console.log('Racers:', this.racers);
      },
      error: (error) => {
        console.error('Error:', error);
      },
    });
  }

    // Trigger CSV download using the service
    downloadCSV(): void {
      this.organisationService.downloadCSV().subscribe({
        next: (response: Blob) => {
          // Create a URL for the Blob response and trigger the download
          const url = window.URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'racers.csv'; // Filename of the CSV
          link.click();
          window.URL.revokeObjectURL(url); // Clean up the URL object
        },
        error: (error) => {
          console.error('Error downloading CSV:', error);
        },
      });
    }
}
